export default __webpack_public_path__ + "static/media/ReactMeta.cecd4599.PNG";